// Стартовый файл намеренно крошечный: поднимает словари и Telegram, и только
// потом подгружает само приложение (boot.tsx → App).
//
// Порядок важен. Словари активного языка приезжают отдельным чанком
// (см. i18n/index.ts), а модули приложения считают подписи на уровне модуля —
// поэтому App нельзя импортировать статически: он выполнился бы раньше
// словарей. Ничего, что зовёт `i18n.t()` при импорте, сюда добавлять нельзя.
import { initI18n } from './i18n'
// Стили: Tailwind собирается из index.css при сборке (с 14.10; до этого сайт
// жил на замороженном CSS от 09.10 и новые классы не появлялись).
import './index.css'
import './store/useThemeStore' // initialize theme on load
import { bootTelegram } from './utils/telegram'

// Метка сборки. Меняется при выкате, когда нужно, чтобы у главного файла
// гарантированно сменилось имя: 28.09 Cloudflare закэшировал HTML под именем
// index-*.js, и сайт стоял чёрным экраном до смены адреса.
(window as any).__SB_BUILD__ = '1790621773';

// Словари и скрипт Telegram грузим одновременно — они друг от друга не
// зависят. Внутри Telegram Mini App bootTelegram поднимает скрипт Telegram
// (initData для входа, тема); на обычном сайте выходит сразу. Его ошибка
// старту не мешает (раньше здесь стоял .finally с тем же смыслом).
void Promise.all([
  initI18n(),
  bootTelegram().catch(() => { /* без Telegram — обычный сайт */ }),
])
  .then(() => import('./boot'))
  .then(({ mount }) => mount())
